"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _reactHelmet = require("react-helmet"),
    _FileTypeIcon = _interopRequireDefault(require("../../FileTypeIcon"));

require("../styles/_font-preview.scss");

function getFontFace(asset, fontFamily) {
  var assetFiles = asset.assetFiles;
  return "@font-face {\n    font-family: '".concat(fontFamily, "';\n    src: url(").concat(assetFiles.ORIGINAL.sourceUrl, ");\n  }");
}

function FontPreview(_ref) {
  var asset = _ref.asset,
      hideFileTypeIcon = _ref.hideFileTypeIcon,
      assetId = asset.assetId,
      fontFamily = "CustomFont-".concat(assetId);
  return _react["default"].createElement("div", {
    className: "font-preview"
  }, _react["default"].createElement(_reactHelmet.Helmet, null, _react["default"].createElement("style", {
    type: "text/css"
  }, "".concat(getFontFace(asset, fontFamily)))), _react["default"].createElement("p", {
    style: {
      fontFamily: "".concat(fontFamily, ", Poppins")
    },
    className: "font-preview__snippet"
  }, "ABC abc"), !hideFileTypeIcon && _react["default"].createElement(_FileTypeIcon["default"], {
    name: "typography",
    size: 20
  }));
}

var _default = (0, _react.memo)(FontPreview);

exports["default"] = _default;